import type { ResolvedLinkProps } from "types/storyblok.d";
import { DEFAULT_FALLBACK_LANGUAGE, type LanguageCode } from "config/languages";
import { getSlugWithoutLocale } from "utils/getSlugWithoutLocale";
import { getDefaultFolder, isDefaultLanguage } from "utils/isDefaultLanguage";
import { getLocaleFromFullSlug, getLocaleFromUrl } from "utils/getLocale";
import { getParentLanguage } from "utils/localeUtils";

export const getUrlFromLink = (link: ResolvedLinkProps, language?: LanguageCode): string => {
  if (!link) return undefined;

  const localeFromSlug = getLocaleFromFullSlug(link.story?.full_slug);
  const localeFromUrl = getLocaleFromUrl(link.cached_url || link.url);

  const locale = localeFromSlug || localeFromUrl;

  const isDefaultLinkLocale = isDefaultLanguage(locale);

  let storyLink: string;
  let storyUrl: string;

  if (isDefaultLinkLocale) {
    const storySlug = getSlugWithoutLocale(link.story?.full_slug);

    const isCurrentLanguageDefault = getDefaultFolder(language);

    const isSameDefault = getParentLanguage(locale) === getParentLanguage(language);

    const fallbackLocale = locale === "en-default" ? DEFAULT_FALLBACK_LANGUAGE : getParentLanguage(locale);
    const linkLocale = isCurrentLanguageDefault && isSameDefault ? language : fallbackLocale;

    storyLink = storySlug ? `/${linkLocale}/${storySlug}` : "";
    storyUrl = `/${linkLocale}/${getSlugWithoutLocale(link.url)}`;

    return storyLink || storyUrl;
  }

  const storyFullSlug = link.story?.full_slug;
  storyLink = storyFullSlug ? `/${storyFullSlug}` : "";
  storyUrl = link.url;

  return storyLink || storyUrl;
};
